import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_BETA_LOCALES_ENABLED = createFcmDetails('beta_locales_enabled', {
	owner: 'Site Platform',
	context: 'Locales used on the site',
	description: `
		Enable beta locales on the site. This will not impact the locale selector in the footer but will allow setting the locale using ?lang=<locale_code>.

		Only global group is supported.
	`,
	import: false,
});
